import React, { useEffect } from "react";
import useAutoChat from "./useAutoChat";
import ChartAwareMarkdown from "../ChartAwareMarkdown";
import CountiesChart from "./CountiesChart";

const AI_QUERY = "Show me the latest overview of conditions in Africa";

export default function AiOverview({ onLoaded, cdiOverviewData }) {
  const { response, chartData, isLoading, error, progress } = useAutoChat(AI_QUERY);

  // Check whether AI provided a non-empty cdi_overview
  const aiHasCdiOverview = chartData?.cdi_overview &&
    (Array.isArray(chartData.cdi_overview) ? chartData.cdi_overview.length > 0 : Object.keys(chartData.cdi_overview).length > 0);

  useEffect(() => {
    if (!isLoading && response && onLoaded) {
      onLoaded();
    }
  }, [isLoading, response, onLoaded]);

  return (
    <div className="ai-overview">
      <div className="ai-overview-header">
        <span className="ai-overview-title">AI-powered Analytics</span>
        <a href="/drought-chat" className="button is-small is-rounded ai-chat-link">
          Chat with AI
        </a>
      </div>

      <div className="ai-overview-body">
        {isLoading && (
          <div className="ai-overview-loading">
            <span className="loader ai-spinner" />
            <span>{progress?.detail || "Generating overview…"}</span>
            {typeof progress?.pct === "number" && (
              <progress
                className="progress is-small is-info"
                value={progress.pct}
                max="100"
                style={{ marginTop: 8 }}
              >
                {progress.pct}%
              </progress>
            )}
          </div>
        )}

        {error && !isLoading && (
          <div className="notification is-warning is-light">
            <p>Could not load AI overview. <a href="/drought-chat">Try the full chat instead.</a></p>
          </div>
        )}

        {response && !isLoading && (
          <div className="ai-overview-content">
            <ChartAwareMarkdown text={response} chartData={chartData} />
            {/* Fallback: show flagged CDI chart if AI didn't provide cdi_overview */}
            {!aiHasCdiOverview && cdiOverviewData && (
              <div style={{ marginTop: 12 }}>
                <p style={{ fontWeight: 600, marginBottom: 8, fontSize: 13, color: '#555' }}>CDI Regional Overview</p>
                <CountiesChart data={cdiOverviewData} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
